import {Component, HostListener} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {LayoutService} from '../../core/services/layout.service';
import {AsyncPipe, NgClass} from '@angular/common';
import {AppSidebarComponent} from './components/app-sidebar/app-sidebar.component';
import {AppHeaderComponent} from './components/app-header/app-header.component';
import {AppFooterComponent} from './components/app-footer/app-footer.component';
import {UiStateService} from '../../core/services/ui-state.service';
import {ModalComponent} from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-admin-layout',
  imports: [
    RouterOutlet,
    AsyncPipe,
    AppSidebarComponent,
    AppHeaderComponent,
    AppFooterComponent,
    NgClass,
    ModalComponent
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 1200) {
      this.layoutService.setMobileOpen(false);
      this.layoutService.setHovered(false);
    }
  }

  constructor(public layoutService: LayoutService, public ui: UiStateService) {
  }
}
